// material-ui
import { Button, Dialog, DialogContent, Stack, Typography } from "@mui/material";

// project-imports
import Avatar from "components/@extended/Avatar";
import { PopupTransition } from "components/@extended/Transitions";
import PropTypes from "prop-types";
// assets
import { Trash } from "iconsax-react";

// ==============================|| CUSTOMER - DELETE ||============================== //

export default function AlertDelete({ text, title, open, handleClose, handleDelete }) {
  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="column-delete-title"
      aria-describedby="column-delete-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar color="error" sx={{ width: 72, height: 72, fontSize: "1.75rem" }}>
            <Trash variant="Bold" />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              Are you sure you want to delete?
            </Typography>
            <Typography align="center">
              By deleting
              <Typography variant="subtitle1" component="span">
                {" "}
                &quot;{title}&quot;{" "}
              </Typography>
              {text && (
                <Typography variant="subtitle1" component="span">
                  {" "}
                  {text}{" "}
                </Typography>
              )}
              will be permanently removed from your account.
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button fullWidth onClick={() => handleClose(false)} color="secondary" variant="outlined">
              Cancel
            </Button>
            <Button fullWidth color="error" variant="contained" onClick={() => handleDelete()} autoFocus>
              Delete
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

AlertDelete.propTypes = {
  handleClose: PropTypes.func,
  handleDelete: PropTypes.any,
  open: PropTypes.bool,
  text: PropTypes.any,
  title: PropTypes.string
};
